export default __webpack_public_path__ + "static/media/AxionAccelerator.d9c7b84f.svg";